import { scaleLinear } from "d3";
import getBaseTickFormat from "../../helpers/getBaseTickFormat";

function getTick(x, scale, isLog) {
  const numLog = x === 0.1 ? 0 : 10 ** x;
  const num = isLog ? numLog : x;
  const helpText = isLog ? String(10 ** x) : String(x);
  return {
    tick: String(x),
    label: getBaseTickFormat(num),
    helpText,
    y: scale(x),
  };
}

function getCoverageTicks(min, max, isLog) {
  const scale = scaleLinear().domain([max, min]).range([0, 1]);
  return scale
    .ticks(5)
    .filter((x) => x % 1 === 0)
    .map((x) => getTick(x, scale, isLog));
}

export default getCoverageTicks;
